module.exports = __webpack_public_path__ + "img/class-features.2b6bad30.png";